import React from "react";
import "./Withdrawal.css";

function Withdrawal() {
  return (
    <div className="Withdrawal">
      <body className="Withdrawal-body">
        <h1>LIFE MISSION の退会について</h1>
        <p>
          Apple の設定アプリからサブスクリプションの解除を行うことで退会できます
          <br />
          ※退会後に、再度入会する場合、その時に提示してあるプラン、料金でのみ利用可能です
        </p>
      </body>
    </div>
  );
}

export default Withdrawal;
